<template>
  <router-link :to="to" :class="{ 'link-button--fullwidth': fullWitdh }">
    <Button
      v-bind="$attrs"
      v-on="$listeners"
      :class="customClass"
      :fullWidth="fullWitdh"
    >
      <slot />
    </Button>
  </router-link>
</template>

<script>
import Button from './Button';

export default {
  name: 'LinkButton',
  components: { Button },
  props: {
    to: {
      type: String,
      required: true,
    },
    customClass: {
      type: String,
      default: null,
    },
    fullWitdh: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .link-button {
    &--fullwidth {
      width: 100%;
    }
  }
</style>
